<template>
  <div>
    <Nav></Nav>
    <b-container>
      <b-row>
        <b-col>
          <h1 v-if="actualSupply.id > 0">
            Insumo
            {{ this.actualSupply.id + " " + this.actualSupply.name }}
          </h1>
          <h1 v-else>Crear Insumo</h1>
        </b-col>
      </b-row>
      <b-card>
        <b-form>
          <b-row>
            <b-col md="3" sm="12">
              <b-form-group label="Clave:">
                <b-form-input v-model="actualSupply.code" type="text" required></b-form-input>
              </b-form-group>
            </b-col>
            <b-col xl="9" md="12">
              <b-form-group label="Nombre:">
                <b-form-input v-model="actualSupply.name" type="text" required></b-form-input>
              </b-form-group>
            </b-col>
            <b-col xl="12" md="12">
              <b-form-group label="Descripcion:">
                <b-form-input v-model="actualSupply.description" type="text" required></b-form-input>
              </b-form-group>
            </b-col>
            <b-col xl="6" md="12">
              <b-form-group label="Unidad:">
                <b-form-input v-model="actualSupply.unit" type="text" required></b-form-input>
              </b-form-group>
            </b-col>
            <b-col xl="6" md="12">
              <b-form-group label="Base:">
                <b-form-input v-model.number="actualSupply.base_portion" type="number" required></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="12" cols="12">
              <b-form-group label="Categoria" description="Selecciona la categoria">
                <vu-select v-model.number="actualSupply.supply_category_id" :options="supplyCategories" :reduce="(x) => x.id"
                  label="name" ></vu-select>
              </b-form-group>
            </b-col>
            <b-col xl="3" md="12">
              <b-form-group label="Status:">
                <b-form-checkbox v-model="actualSupply.status" :value="true" :unchecked-value="false">
                  Activo
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row class="mt-3">
            <b-button v-if="actualSupply.id > 0" block variant="success" @click="updateProduct">Guardar</b-button>
            <b-button v-else block variant="success" @click="updateProduct">Crear</b-button>
          </b-row>
        </b-form>
      </b-card>

      <!-- Tax Management Section -->
      <b-card class="mt-3" v-if="actualSupply.id > 0">
        <template #header>
          <h5 class="mb-0">Configuración de Impuestos</h5>
        </template>
        
        <b-tabs>
          <b-tab title="Reglas de Impuestos" active>
            <div class="mt-3">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <h6>Reglas de Impuestos Aplicables</h6>
                <b-button size="sm" variant="primary" @click="openAddTaxRuleModal">
                  <b-icon icon="plus"></b-icon> Agregar Regla
                </b-button>
              </div>
              
              <b-table 
                :items="supplyTaxRules" 
                :fields="taxRuleFields"
                striped hover small 
                responsive
                show-empty
                empty-text="No hay reglas de impuestos configuradas">
                <template #cell(tax_catalog_id)="row">
                  <span>{{ getTaxCatalogName(row.item.tax_catalog_id) }}</span>
                </template>
                <template #cell(tax_catalog_line_id)="row">
                  {{ getTaxLineName(row.item.tax_catalog_line_id) }}
                </template>
                <template #cell(is_default)="row">
                  <b-badge :variant="row.item.is_default ? 'success' : 'secondary'">
                    {{ row.item.is_default ? 'Sí' : 'No' }}
                  </b-badge>
                </template>
                <template #cell(is_active)="row">
                  <b-badge :variant="row.item.is_active ? 'success' : 'secondary'">
                    {{ row.item.is_active ? 'Activo' : 'Inactivo' }}
                  </b-badge>
                </template>
                <template #cell(actions)="row">
                  <b-button-group size="sm">
                    <b-button variant="info" @click="editTaxRule(row.item)">
                      <b-icon icon="pencil"></b-icon>
                    </b-button>
                    <b-button variant="danger" @click="deleteTaxRule(row.item.id)">
                      <b-icon icon="trash"></b-icon>
                    </b-button>
                  </b-button-group>
                </template>
              </b-table>
            </div>
          </b-tab>
          
          <b-tab title="IEPS Especial">
            <div class="mt-3">
              <b-form-group label="Configuración IEPS" description="Selecciona la tasa IEPS específica para este producto">
                <b-row>
                  <b-col md="6">
                    <b-form-group label="Tipo de IEPS:">
                      <b-form-select v-model="selectedIEPSRate" :options="iepsRateOptions" @change="updateIEPSRate">
                        <template #first>
                          <b-form-select-option :value="null">Sin IEPS</b-form-select-option>
                        </template>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col md="6" v-if="selectedIEPSRate">
                    <b-form-group label="Tasa Actual:">
                      <b-input-group>
                        <b-form-input :value="getIEPSRateValue(selectedIEPSRate)" readonly></b-form-input>
                        <b-input-group-append>
                          <b-input-group-text>%</b-input-group-text>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-form-group>
            </div>
          </b-tab>
        </b-tabs>
      </b-card>

      <!-- Last Buy Price Information Section -->
      <b-card class="mt-3" v-if="actualSupply.id > 0">
        <template #header>
          <h5 class="mb-0">Información de Último Precio de Compra</h5>
        </template>

        <div v-if="lastBuyPriceLoading" class="text-center">
          <b-spinner small class="mr-2"></b-spinner>
          Cargando información de último precio...
        </div>

        <div v-else-if="lastBuyPriceInfo">
          <b-row>
            <b-col md="4">
              <b-form-group label="Último Precio de Compra:">
                <h4 class="text-success mb-0">
                  <strong>${{ formatPrice(lastBuyPriceInfo.last_buy_price) }}</strong>
                </h4>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Fecha de Última Compra:">
                <b-badge variant="info" class="p-2">
                  <b-icon icon="calendar"></b-icon>
                  {{ formatDate(lastBuyPriceInfo.last_buy_date) }}
                </b-badge>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Proveedor:">
                <b-badge variant="primary" class="p-2">
                  <b-icon icon="building"></b-icon>
                  {{ lastBuyPriceInfo.provider_name || 'N/A' }}
                </b-badge>
              </b-form-group>
            </b-col>
          </b-row>

          <b-alert show variant="info" class="mt-3">
            <small>
              <b-icon icon="info-circle"></b-icon>
              Esta información se actualiza automáticamente cuando se completan órdenes de compra de proveedores externos con precios válidos.
            </small>
          </b-alert>
        </div>

        <b-alert show variant="warning" v-else>
          <b-icon icon="exclamation-triangle"></b-icon>
          No hay información de precios de compra disponible para este insumo.
        </b-alert>

        <div class="text-right mt-3">
          <b-button size="sm" variant="outline-primary" @click="refreshLastBuyPrice">
            <b-icon icon="arrow-clockwise"></b-icon>
            Actualizar
          </b-button>
        </div>
      </b-card>

      <!-- Add Tax Rule Modal -->
      <b-modal id="modal-add-tax-rule" v-model="showAddTaxRule" :title="taxRuleForm.id ? 'Editar Regla de Impuesto' : 'Agregar Regla de Impuesto'" size="lg" @hidden="resetTaxRuleForm" @show="onModalShow">
        <b-form>
          <b-row>
            <b-col md="6">
              <b-form-group label="Catálogo de Impuestos:" required>
                <b-form-select v-model="taxRuleForm.tax_catalog_id" :options="taxCatalogOptions" required>
                  <template #first>
                    <b-form-select-option :value="null" disabled>Selecciona un catálogo</b-form-select-option>
                  </template>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Línea de Impuesto:" required>
                <b-form-select v-model="taxRuleForm.tax_catalog_line_id" :options="taxLineOptions" :disabled="!taxRuleForm.tax_catalog_id" required>
                  <template #first>
                    <b-form-select-option :value="null" disabled>Selecciona una línea</b-form-select-option>
                  </template>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <b-form-group label="Prioridad:">
                <b-form-input v-model.number="taxRuleForm.priority" type="number" min="1" max="10" placeholder="1"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <b-form-checkbox v-model="taxRuleForm.is_default">Regla por defecto</b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <b-form-checkbox v-model="taxRuleForm.is_active">Activo</b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group label="Vigente desde:">
                <b-form-input v-model="taxRuleForm.effective_from" type="date"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Vigente hasta:">
                <b-form-input v-model="taxRuleForm.effective_to" type="date"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
        
        <template #modal-footer="{ hide }">
          <b-button variant="secondary" @click="hide">Cancelar</b-button>
          <b-button variant="primary" @click="saveTaxRule" :disabled="!isValidTaxRule">{{ taxRuleForm.id ? 'Actualizar' : 'Guardar' }}</b-button>
        </template>
      </b-modal>

    </b-container>
  </div>
</template>
<script>
import Nav from "../components/Nav.vue";
import axios from "axios";
import vSelect from "vue-select";

export default {
  name: "Supply",
  components: { 
    Nav,
    "vu-select": vSelect
  },
  data() {
    return {
      supplyTaxRules: [],
      supplyCategories: [],
      taxCatalogs: [],
      taxLines: [],
      show: false,
      showAddTaxRule: false,
      selectedIEPSRate: null,
      taxRuleForm: {
        id: null,
        supply_id: null,
        tax_catalog_id: null,
        tax_catalog_line_id: null,
        priority: 1,
        is_default: false,
        is_active: true,
        effective_from: null,
        effective_to: null
      },
      taxRuleFields: [
        { key: 'tax_catalog_id', label: 'Catálogo' },
        { key: 'tax_catalog_line_id', label: 'Tasa' },
        { key: 'priority', label: 'Prioridad' },
        { key: 'is_default', label: 'Por Defecto' },
        { key: 'is_active', label: 'Estado' },
        { key: 'actions', label: 'Acciones' }
      ],
      actualSupply: {
        id: 0,
        description: "",
        code: "",
        name: "",
        unit: "",
        base_portion: 1,
        status: true,
        supply_category_id: null
      },
      lastBuyPriceInfo: null,
      lastBuyPriceLoading: false,
    };
  },
  computed: {
    taxCatalogOptions() {
      return this.taxCatalogs.map(catalog => ({
        value: catalog.id,
        text: catalog.name
      }));
    },
    taxLineOptions() {
      return this.taxLines.map(line => ({
        value: line.id,
        text: `${line.rate_name} (${line.rate_value}%)`
      }));
    },
    iepsRateOptions() {
      return [
        { value: 'Cerveza', text: 'Cerveza (26.5%)' },
        { value: 'Bebidas Alcohólicas', text: 'Bebidas Alcohólicas (53.0%)' },
        { value: 'Tabacos Labrados', text: 'Tabacos Labrados (160.0%)' },
        { value: 'Bebidas Energizantes', text: 'Bebidas Energizantes (25.0%)' },
        { value: 'Bebidas Saborizadas', text: 'Bebidas Saborizadas (8.0%)' }
      ];
    },
    isValidTaxRule() {
      return this.taxRuleForm.tax_catalog_id && 
             this.taxRuleForm.tax_catalog_line_id && 
             this.taxRuleForm.priority > 0;
    }
  },
  beforeRouteUpdate(to, from, next) {
    // On an in-component route change (e.g. after creating a supply we push /supply/:id on the
    // same component) `this.$route` still points at the OLD route, so pass the target id from `to`.
    this.initData(to.params.id);
    next();
  },
  mounted() {
    this.initData();
  },
  watch: {
    async 'actualSupply.id'(newId) {
      if (newId > 0) {
        // Load tax catalogs first, then tax rules
        await this.getTaxCatalogs();
        await this.getSupplyTaxRules();
        // Load last buy price information
        await this.getLastBuyPrice();
      }
    },
    async 'taxRuleForm.tax_catalog_id'(newId, oldId) {
      // Only clear the line selection if this is not an edit operation
      // (edit operations set the catalog_id first, then the line_id)
      if (!this.taxRuleForm.id) {
        this.taxRuleForm.tax_catalog_line_id = null;
      }
      
      if (newId && newId !== oldId) {
        await this.getTaxLines(newId);
      } else if (!newId) {
        this.taxLines = [];
        this.taxRuleForm.tax_catalog_line_id = null;
      }
    }
  },
  methods: {
    initData(routeId) {
      this.getSupplyCategories()
      // Use the id passed by beforeRouteUpdate (the new route) when available; otherwise fall back
      // to the current route (fresh mount / edit link).
      const supplyId = routeId !== undefined ? routeId : this.$route.params.id;
      if (supplyId > 0) {
        this.actualSupply.id = supplyId;
        this.getSupply();
      }
    },
    getSupplyCategories() {
      let that = this;
      axios
        .get("/supplycategories")
        .then(function (response) {
          that.supplyCategories = response.data;
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    getSupply() {
      let that = this;
      axios
        .get("/supply/" + this.actualSupply.id)
        .then(function (response) {
          that.actualSupply = response.data;
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    updateProduct() {
      let that = this;
      if (this.actualSupply.id > 0) {
        axios
          .put("/supply/" + this.actualSupply.id, this.actualSupply)
          .then(function (response) {
            that.actualSupply = response.data;
            that.makeToast("Exito", "exito al guardar", "success");
            that.getSupply();
            that.$router.push({
              name: "Supplies",
            });
          })
          .catch(function (err) {
            that.makeToast("Error", err.request.response, "danger");
          });
      } else {
        this.actualSupply.status = true;
        axios
          .post("/supply", this.actualSupply)
          .then(function (response) {
            that.makeToast("Exito", "exito al crear, redirigiendo", "success");
            console.log(response.data);
            that.$router.push({
              name: "Supply",
              params: { id: response.data.id },
            });
          })
          .catch(function (err) {
            that.makeToast("Error", err.request.response, "danger");
          });
      }
    },

    // Last Buy Price methods
    async getLastBuyPrice() {
      if (!this.actualSupply.id || this.actualSupply.id <= 0) return;

      this.lastBuyPriceLoading = true;
      try {
        const response = await axios.get(`/supplies/${this.actualSupply.id}/last-buy-price`);
        this.lastBuyPriceInfo = response.data;
      } catch (error) {
        console.warn('No last buy price data available:', error);
        this.lastBuyPriceInfo = null;
      } finally {
        this.lastBuyPriceLoading = false;
      }
    },

    refreshLastBuyPrice() {
      this.getLastBuyPrice();
    },

    formatPrice(price) {
      if (!price) return '0.00';
      return parseFloat(price).toFixed(2);
    },

    formatDate(dateString) {
      if (!dateString) return 'N/A';
      const date = new Date(dateString);
      return date.toLocaleDateString('es-MX', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    },

    // Tax management methods
    async getTaxCatalogs() {
      try {
        console.log('Supply.vue - Loading tax catalogs...');
        const response = await axios.get('/tax-catalogs');
        console.log('Supply.vue - Tax catalogs loaded:', response.data);
        
        this.taxCatalogs = response.data || [];
        
        // Load tax lines for each catalog in parallel
        const catalogPromises = this.taxCatalogs.map(async (catalog) => {
          if (catalog.id) {
            try {
              const linesResponse = await axios.get(`/tax-catalogs/${catalog.id}`);
              catalog.tax_lines = linesResponse.data.tax_lines || [];
              console.log(`Supply.vue - Loaded ${catalog.tax_lines.length} tax lines for catalog ${catalog.id}`);
            } catch (err) {
              console.error(`Supply.vue - Error loading tax lines for catalog ${catalog.id}:`, err);
              catalog.tax_lines = [];
            }
          }
          return catalog;
        });
        
        await Promise.all(catalogPromises);
        console.log('Supply.vue - Final tax catalogs with lines:', this.taxCatalogs);
        return this.taxCatalogs;
      } catch (err) {
        console.error('Supply.vue - Error loading tax catalogs:', err);
        this.makeToast('Error', err.response?.data || 'Error al cargar catálogos de impuestos', 'danger');
        this.taxCatalogs = [];
        return [];
      }
    },
    async getTaxLines(catalogId) {
      try {
        console.log('Supply.vue - Loading tax lines for catalog:', catalogId);
        
        // First try to get from already loaded catalogs
        const catalog = this.taxCatalogs.find(c => c.id === catalogId);
        if (catalog && catalog.tax_lines && catalog.tax_lines.length > 0) {
          this.taxLines = catalog.tax_lines;
          console.log('Supply.vue - Using cached tax lines:', this.taxLines);
          return this.taxLines;
        }
        
        // If not found in cache, fetch from API
        const response = await axios.get(`/tax-catalogs/${catalogId}`);
        this.taxLines = response.data.tax_lines || [];
        console.log('Supply.vue - Tax lines loaded from API:', this.taxLines);
        
        // Update the cached catalog
        if (catalog) {
          catalog.tax_lines = this.taxLines;
        }
        
        return this.taxLines;
      } catch (err) {
        console.error('Supply.vue - Error loading tax lines:', err);
        this.taxLines = [];
        this.makeToast('Error', err.response?.data || 'Error al cargar líneas de impuestos', 'danger');
        return [];
      }
    },
    async getSupplyTaxRules() {
      console.log('Supply.vue - Loading supply tax rules for supply ID:', this.actualSupply.id);
      if (!this.actualSupply.id) return [];
      
      try {
        const response = await axios.get(`/supply-tax-rules?supply_id=${this.actualSupply.id}`);
        this.supplyTaxRules = response.data || [];
        
        // Enhanced logging for tax rule data
        this.supplyTaxRules.forEach((rule, index) => {
          console.log(`Supply.vue - Rule ${index}:`, {
            id: rule.id,
            supply_id: rule.supply_id,
            tax_catalog_id: rule.tax_catalog_id,
            tax_catalog: rule.tax_catalog,
            tax_catalog_line_id: rule.tax_catalog_line_id,
            tax_catalog_line: rule.tax_catalog_line,
            priority: rule.priority,
            is_active: rule.is_active
          });
        });
        
        return this.supplyTaxRules;
      } catch (err) {
        console.error('Supply.vue - Error loading supply tax rules:', err);
        this.supplyTaxRules = [];
        this.makeToast('Error', err.response?.data || 'Error al cargar reglas de impuestos', 'danger');
        return [];
      }
    },
    getTaxBadgeVariant(taxCode) {
      const variants = {
        'IVA': 'primary',
        'IEPS': 'warning',
        'ISR': 'info',
        'CEDULA': 'secondary'
      };
      return variants[taxCode] || 'light';
    },
    getTaxCatalogName(catalogId) {
      // Check if we have the catalog info in the tax rules themselves
      for (let rule of this.supplyTaxRules) {
        if (rule.tax_catalog_id === catalogId && rule.tax_catalog) {
          return `${rule.tax_catalog.name} (${rule.tax_catalog.tax_code})`;
        }
      }
      // Fallback to loaded tax catalogs
      const catalog = this.taxCatalogs.find(c => c.id === catalogId);
      return catalog ? catalog.name : 'N/A';
    },
    getTaxLineName(lineId) {
      console.log("Getting tax line name for ID:", lineId); // Debug log
      console.log("Available tax lines:", this.taxLines); // Debug log
      console.log("Supply tax rules:", this.supplyTaxRules); // Debug log
      
      // Check if we have the tax line info in the tax rules themselves
      for (let rule of this.supplyTaxRules) {
        if (rule.tax_catalog_line_id === lineId && rule.tax_catalog_line) {
          return `${rule.tax_catalog_line.rate_name} (${rule.tax_catalog_line.rate_value}%)`;
        }
      }
      
      // Fallback to loaded tax lines
      const line = this.taxLines.find(l => l.id === lineId);
      if (line) {
        return `${line.rate_name} (${line.rate_value}%)`;
      }
      
      // Last resort: try to load tax line from all available catalogs
      for (let catalog of this.taxCatalogs) {
        if (catalog.tax_lines) {
          const line = catalog.tax_lines.find(l => l.id === lineId);
          if (line) {
            return `${line.rate_name} (${line.rate_value}%)`;
          }
        }
      }
      
      return 'N/A';
    },
    getTaxLineValue(lineId) {
      const line = this.taxLines.find(l => l.id === lineId);
      return line ? `${line.rate_value}%` : 'N/A';
    },
    saveTaxRule() {
      if (!this.isValidTaxRule) return;
      
      let that = this;
      const requestBody = {
        supply_id: this.actualSupply.id,
        tax_catalog_id: this.taxRuleForm.tax_catalog_id,
        tax_catalog_line_id: this.taxRuleForm.tax_catalog_line_id,
        is_default: this.taxRuleForm.is_default,
        priority: this.taxRuleForm.priority,
        is_active: this.taxRuleForm.is_active
      };
      
      if (this.taxRuleForm.effective_from) {
        requestBody.effective_from = this.taxRuleForm.effective_from + ' 00:00:00';
      }
      
      const method = this.taxRuleForm.id ? 'put' : 'post';
      const url = this.taxRuleForm.id ? `/supply-tax-rules/${this.taxRuleForm.id}` : '/supply-tax-rules';
      console.log(method)
      console.log(url)
      axios[method](url, requestBody)
        .then(function () {
          that.makeToast("Éxito", "Regla de impuesto guardada exitosamente", "success");
          that.getSupplyTaxRules();
          that.showAddTaxRule = false;
          that.resetTaxRuleForm();
        })
        .catch(function (err) {
          that.makeToast("Error", err.response?.data || "Error al guardar regla de impuesto", "danger");
        });
    },
    async editTaxRule(rule) {
      console.log('Supply.vue - Editing tax rule with ID:', rule.id);
      
      try {
        // Make API call to get complete tax rule data with nested relationships
        console.log('Supply.vue - Fetching complete tax rule data from API...');
        const response = await axios.get(`/supply-tax-rules/${rule.id}`);
        const completeRule = response.data;
        
        console.log('Supply.vue - Complete rule data received:', completeRule);
        console.log('Supply.vue - Date values:', {
          effective_from_raw: completeRule.effective_from,
          effective_to_raw: completeRule.effective_to,
          effective_from_formatted: this.formatDateForInput(completeRule.effective_from),
          effective_to_formatted: this.formatDateForInput(completeRule.effective_to)
        });
        
        // Ensure tax catalogs are loaded
        if (!this.taxCatalogs || this.taxCatalogs.length === 0) {
          console.log('Supply.vue - Loading tax catalogs...');
          await this.getTaxCatalogs();
        }
        
        // First populate the form with the catalog ID to prevent watcher interference
        this.taxRuleForm = {
          id: completeRule.id,
          supply_id: completeRule.supply_id,
          tax_catalog_id: completeRule.tax_catalog_id,
          tax_catalog_line_id: null, // Set to null initially to prevent watcher clearing
          priority: completeRule.priority || 1,
          is_default: completeRule.is_default || false,
          is_active: completeRule.is_active !== undefined ? completeRule.is_active : true,
          effective_from: this.formatDateForInput(completeRule.effective_from),
          effective_to: this.formatDateForInput(completeRule.effective_to)
        };
        
        // Load tax lines for the catalog
        if (completeRule.tax_catalog_id) {
          console.log('Supply.vue - Loading tax lines for catalog:', completeRule.tax_catalog_id);
          await this.getTaxLines(completeRule.tax_catalog_id);
          
          // Ensure the specific tax line is available in the dropdown
          if (completeRule.tax_catalog_line && completeRule.tax_catalog_line_id) {
            const existingLine = this.taxLines.find(line => line.id === completeRule.tax_catalog_line_id);
            if (!existingLine) {
              console.log('Supply.vue - Adding tax line from API data:', completeRule.tax_catalog_line);
              this.taxLines.push({
                id: completeRule.tax_catalog_line_id,
                rate_name: completeRule.tax_catalog_line.rate_name,
                rate_value: completeRule.tax_catalog_line.rate_value
              });
            }
          }
          
          // Wait for Vue to process the tax lines update
          await this.$nextTick();
          
          // Now set the tax_catalog_line_id after tax lines are loaded
          this.taxRuleForm.tax_catalog_line_id = completeRule.tax_catalog_line_id;
        }
        
        console.log('Supply.vue - Form populated:', this.taxRuleForm);
        console.log('Supply.vue - Tax line options available:', this.taxLineOptions.length);
        
        // Wait for all updates to complete before showing modal
        await this.$nextTick();
        this.showAddTaxRule = true;
        
      } catch (err) {
        console.error('Supply.vue - Error loading tax rule:', err);
        this.makeToast('Error', 'Error al cargar datos de la regla de impuesto', 'danger');
      }
    },
    deleteTaxRule(ruleId) {
      this.$bvModal.msgBoxConfirm('¿Estás seguro de que quieres eliminar esta regla de impuesto?', {
        title: 'Confirmar eliminación',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Eliminar',
        cancelTitle: 'Cancelar',
        centered: true
      })
      .then(value => {
        if (value) {
          let that = this;
          axios
            .delete(`/supply-tax-rules/${ruleId}`)
            .then(function () {
              that.makeToast("Éxito", "Regla de impuesto eliminada exitosamente", "success");
              that.getSupplyTaxRules();
            })
            .catch(function (err) {
              that.makeToast("Error", err.response?.data || "Error al eliminar regla de impuesto", "danger");
            });
        }
      });
    },
    resetTaxRuleForm() {
      console.log('Supply.vue - Resetting tax rule form');
      this.taxRuleForm = {
        id: null, // Make sure ID is reset for new rules
        supply_id: this.actualSupply.id,
        tax_catalog_id: null,
        tax_catalog_line_id: null,
        priority: 1,
        is_default: false,
        is_active: true,
        effective_from: null,
        effective_to: null
      };
      this.taxLines = []; // Clear tax lines
      console.log('Supply.vue - Tax rule form reset to:', this.taxRuleForm);
    },
    async openAddTaxRuleModal() {
      console.log('Supply.vue - Opening add tax rule modal');
      
      // Ensure tax catalogs are loaded before opening modal
      if (!this.taxCatalogs || this.taxCatalogs.length === 0) {
        console.log('Supply.vue - Loading tax catalogs before opening modal...');
        await this.getTaxCatalogs();
      }
      
      this.resetTaxRuleForm();
      this.showAddTaxRule = true;
    },
    async onModalShow() {
      console.log('Supply.vue - Modal is showing, ensuring tax catalogs are loaded');
      
      // Double-check that tax catalogs are loaded when modal shows
      if (!this.taxCatalogs || this.taxCatalogs.length === 0) {
        console.log('Supply.vue - Loading tax catalogs on modal show...');
        await this.getTaxCatalogs();
      }
      
      console.log('Supply.vue - Available tax catalogs:', this.taxCatalogs.length);
      console.log('Supply.vue - Current form state:', this.taxRuleForm);
      console.log('Supply.vue - Available tax lines:', this.taxLines.length);
      console.log('Supply.vue - Tax line options:', this.taxLineOptions);
      
      // If we have a tax_catalog_id but no tax lines, try to load them
      if (this.taxRuleForm.tax_catalog_id && (!this.taxLines || this.taxLines.length === 0)) {
        console.log('Supply.vue - Form has catalog ID but no tax lines, loading...');
        await this.getTaxLines(this.taxRuleForm.tax_catalog_id);
      }
      
      // Small delay to ensure Vue reactivity updates
      await this.$nextTick();
      
      console.log('Supply.vue - Final modal state check:');
      console.log('  - Tax catalogs:', this.taxCatalogs.length);
      console.log('  - Tax lines:', this.taxLines.length);
      console.log('  - Selected catalog ID:', this.taxRuleForm.tax_catalog_id);
      console.log('  - Selected line ID:', this.taxRuleForm.tax_catalog_line_id);
      console.log('  - Tax line options available:', this.taxLineOptions.length);
    },
    updateIEPSRate() {
      if (!this.selectedIEPSRate || !this.actualSupply.id) return;
      
      let that = this;
      const requestData = {
        supply_id: this.actualSupply.id,
        ieps_rate_name: this.selectedIEPSRate
      };
      
      axios
        .post("/update-product-ieps-rate", requestData)
        .then(function () {
          that.makeToast("Éxito", "Tasa IEPS actualizada exitosamente", "success");
          that.getSupplyTaxRules();
        })
        .catch(function (err) {
          that.makeToast("Error", err.response?.data || "Error al actualizar tasa IEPS", "danger");
        });
    },
    getIEPSRateValue(rateName) {
      const rates = {
        'Cerveza': '26.5',
        'Bebidas Alcohólicas': '53.0',
        'Tabacos Labrados': '160.0',
        'Bebidas Energizantes': '25.0',
        'Bebidas Saborizadas': '8.0'
      };
      return rates[rateName] || '0.0';
    },
    formatDateForInput(dateValue) {
      if (!dateValue) return null;
      
      try {
        // Handle different date formats that might come from the API
        let date;
        
        if (typeof dateValue === 'string') {
          // If it's already in YYYY-MM-DD format, return as is
          if (/^\d{4}-\d{2}-\d{2}$/.test(dateValue)) {
            return dateValue;
          }
          
          // If it contains 'T' (ISO format), split on 'T'
          if (dateValue.includes('T')) {
            date = new Date(dateValue);
          } else {
            date = new Date(dateValue);
          }
        } else {
          date = new Date(dateValue);
        }
        
        // Check if date is valid
        if (isNaN(date.getTime())) {
          console.warn('Supply.vue - Invalid date value:', dateValue);
          return null;
        }
        
        // Format as YYYY-MM-DD for HTML date input
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        
        return `${year}-${month}-${day}`;
      } catch (err) {
        console.error('Supply.vue - Error formatting date:', dateValue, err);
        return null;
      }
    },
    makeToast(title, content, variant) {
      this.$bvToast.toast(content, {
        title,
        variant,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
  },
};
</script>

<style>
@import "~vue-select/dist/vue-select.css";
</style>
